import DateModel from "~/pages/sample/calendar/DateModel";

/**
 * 날짜관련 유틸리티
 */
const coreDateUtil = {

    getToday:()=>{
        return new Date();
    },

    /**
     * 오늘 날짜 가져오기
     */
    getTodayString:(delim) =>{
        const year = coreDateUtil.getThisYear();
        const month = coreDateUtil.getThisMonth();
        const day = coreDateUtil.getThisDate();

        return year+delim+month+delim+day;
    },

    getDateString:(date, delim) =>{
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        return year+delim+month+delim+day;
    },

    getTimeString(date, delim){
        const hour = date.getHours();
        const minute = date.getMinutes();
        return hour + delim + minute;
    },

    /**
     * 올해 연도 조회
     */
    getThisYear:() => {
        return coreDateUtil.getToday().getFullYear();
    },


      /**
   * 올해 연도에서 뒤에서 2째 자리 자름
   */
  getThisYearBack2:() => {

	  let year = coreDateUtil.getToday().getFullYear();
      return year.toString().slice(-2);
  },

    /**
     * 현재 월 조회
     */
    getThisMonth:() => {
        return coreDateUtil.getToday().getMonth() + 1;
    },

    /**
     * 현재 일 조회
     */
    getThisDate:() => {
        return coreDateUtil.getToday().getDate();
    },

    /**
     * 연도와 월을 받아서 날짜 데이터 만들기
     */
    getDaysForYearMonth: (year, month) => {
        const days = [];
        let dayIndex = 1;
        while(true){
            const tempDate = new Date(year, month-1, dayIndex);
            if(tempDate.getDate() !== dayIndex){
                break;
            }
            const dateModelObj = new DateModel(tempDate);
            days.push(dateModelObj);
            dayIndex++;
        }
        return days;
    },

    /**
     * 연도를 받아서 날짜데이터 만들기
     */
    getDaysForYear: (year) => {
        const months = []
        for (let month = 1; month <= 12; month++) {
            const monthData = coreDateUtil.getDaysForYearMonth(year, month);
            months.push( monthData);
        }
        return months;
    },

    /**
     * 달 이름을 가져오기
     * @param {월(1~12)} month
     */
    getMonthName: (month) => {
        const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[month-1];
    },

};

export default coreDateUtil;
